const activeTabReducer = (data = 1, action) => {
    switch (action.type) {
      case 'SET_ACTIVE_TAB':
        data = action.data
        return data
      default:
        return data;
    }
  };
  
export default activeTabReducer;